import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormHexagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFormHexagon"><Path d="M21.1914 6.69238V17.3076L11.998 22.6162L2.80469 17.3076V6.69238L11.998 1.38379L21.1914 6.69238Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormHexagon;
